<template>
    <header :style="{ opacity: hOpacity, display: hide ? 'none' : '' }">
        <img :src="type == 'back' ? headerBack : headerPlain" @click="clicked" />
        <div v-if="avatar" @click="$emit('avatar')" style="position: absolute;width: 40px;height: 40px;right: 20px;top:18px;">
            <img v-if="!customerAvatar" :src="man" style="width: 100%;"  />
            <div style="position: absolute;right: 0px;top: 0px;display: flex;align-items: center;justify-content: space-around;height: 100%;width: 40px;">
                <img v-if="customerAvatar" :src="customerAvatar" style="width: 56px;border-radius: 50%;border: 2px solid white;" />
            </div>
            
        </div>
        <p v-if="avatar && typeof score == 'number'" style="position: absolute;font-size: 50px;color:#2eecd0;width: 115px;z-index:100;display:flex;align-items: center;justify-content:space-around;height:100%" @click="showScore">{{ score }}</p>
    </header>
</template>

<script>

import { mapActions, mapMutations } from 'vuex';

export default {
    props: ['type','avatar','opacity'],
    watch: {
        opacity ( value ) {
            this.hOpacity = value;
            this.hide = value == 0;
        }
    },
    data () {
        return { 
            hOpacity: 1,
            hide: false 
        }
    },
    computed: {
        host () { return this.$store.state.host },
        headerPlain () { return this.$store.state.headerPlain },
        headerBack () { return this.$store.state.headerBack },
        man () { return this.$store.state.man },
        customerAvatar () { return this.$store.state.avatar },
        score () { return this.$store.state.score },
    },
    methods: {
        clicked () {
            this.type == 'back' ? this.$emit('back') : this.$emit('ham');
        },
        showScore () {
            this.getScores();
            this.pushPage('scores');
        },
        ...mapMutations([
            'pushPage'
        ]),
        ...mapActions([
            'getScores'
        ]),
    }
}

</script>

<style lang="scss">
header {
  width: 100%;
  position: relative;
  border-bottom: 2px solid whitesmoke;
  float: left;
  transform: translate3d(0,0,0);
  img {
      width: 100%;
      float: left;
  }
}
</style>